export default function contains (root, n) {
  let node = n
  while (node) {
    if (node === root) {
      return true
    }
    node = node.parentNode
  }

  return false
}



// WEBPACK FOOTER //
// ./components/_util/Dom/contains.js